import { PixType } from '@portal/enum/pix';
import { validateEmail } from '@portal/utils/validate';
import { validateCPF, validateCNPJ } from 'validations-br';
import { unmaskField } from '@portal/services/masks';

export const getPixKeyType = (value: string): PixType | null => {
  if (!value || !value.trim()) return null;

  const trimmed = value.trim();
  if (validateEmail(trimmed)) return PixType.EMAIL;

  const digits = unmaskField(trimmed);
  if (!/^\d+$/.test(digits)) return null;

  if (digits.length === 11) {
    return validateCPF(digits) ? PixType.TAX_IDENTIFIER : PixType.PHONE;
  }
  if (digits.length === 14 && validateCNPJ(digits)) {
    return PixType.TAX_IDENTIFIER;
  }
  if (digits.length >= 10 && digits.length <= 11) {
    return PixType.PHONE;
  }

  return null;
};
